module.exports = __webpack_public_path__ + "img/preview_easter_egg.5f871156.png";